import config from "../../config"
import RequestService from "../RequestService"

const uncompleteTicketWorkflowStep = (id, note, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrl}/ticket_workflow_steps/${id}/uncomplete`, { note: { details: note } }, successCallback, failureCallback)
}

export default uncompleteTicketWorkflowStep;